module.exports = __webpack_public_path__ + "static/media/reply-24px.130cc3d3.svg";